import React from 'react';

const PricingPageContext = React.createContext('pricingPage');

export default PricingPageContext;
